var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWaterIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 68,
    height: 68,
    viewBox: "0 0 68 68",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34 3.66663C34.556 3.66663 35.087 3.89813 35.4654 4.30558L43.7019 13.1739L43.7025 13.1745C43.9243 13.4136 44.1479 13.6541 44.3729 13.8961C47.5337 17.2965 50.9656 20.9886 53.6461 24.9979C56.534 29.3172 58.6666 34.1683 58.6666 39.6666C58.6666 46.2086 56.0678 52.4827 51.4419 57.1086C46.8161 61.7345 40.542 64.3333 34 64.3333C27.458 64.3333 21.1839 61.7345 16.558 57.1086C11.9321 52.4827 9.33331 46.2086 9.33331 39.6666C9.33331 34.167 11.4659 29.3153 14.3538 24.9958C17.036 20.984 20.4705 17.2905 23.633 13.8895C23.856 13.6496 24.0777 13.4112 24.2977 13.1743L24.298 13.1739L32.5345 4.30558C32.9129 3.89813 33.4439 3.66663 34 3.66663ZM34 8.60554L27.2292 15.8957C27.2291 15.8958 27.229 15.8959 27.2289 15.896C27.0245 16.1162 26.8199 16.3364 26.6152 16.5566C23.4021 20.0135 20.1757 23.4847 17.6791 27.219C15.0399 31.1664 13.3333 35.2439 13.3333 39.6666C13.3333 45.1478 15.5107 50.4044 19.3864 54.2802C23.2622 58.1559 28.5188 60.3333 34 60.3333C39.4811 60.3333 44.7378 58.1559 48.6135 54.2802C52.4893 50.4044 54.6666 45.1478 54.6666 39.6666C54.6666 35.2454 52.9601 31.1687 50.3209 27.2211C47.8258 23.4892 44.6019 20.0194 41.3908 16.5634C41.1841 16.3409 40.9774 16.1184 40.771 15.896C40.7708 15.8958 40.7706 15.8956 40.7704 15.8954L34 8.60554Z",
    fill: "url(#paint0_linear_23_166)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_23_166",
    x1: 9.33331,
    y1: 34,
    x2: 58.6666,
    y2: 34,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2AF598"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#009EFD"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWaterIcon);
export default __webpack_public_path__ + "static/media/water-icon.b435400ed14af12331e17351f383cf61.svg";
export { ForwardRef as ReactComponent };